import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
// routes
import { useRouter } from 'src/routes/hook';
//
import { getPathAfterLogin } from 'src/layouts/dashboard/config-navigation';
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  const router = useRouter();

  const { authenticated } = useAuthContext();

  const check = useCallback(() => {
    if (authenticated) {
      router.replace(getPathAfterLogin());
    }
  }, [authenticated, router]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};
